import AccommodationIndex from "@/views/directory/accommodation/AccommodationIndex.vue";

const accommodation = [
    {
        path: '/accommodations',
        name: 'accomodation',
        component: AccommodationIndex
    }
]

export default accommodation;